export const etudiantsConstants = {
  GET_ETUDIANTS: "GET_ETUDIANTS",
  GET_ETUDIANT: "GET_ETUDIANT",
  GET_RELEVE: "GET_RELEVE_COMPTE",
};
